import { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export function ReactQueryProvider({ children }: PropsWithChildren<unknown>) {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
